import Button from '../../../../../components/Button';
import Tooltip from '../../../../../components/Tooltip';
import ReusePollDrawer from './ReusePollDrawer';
import useReusePoll from './vm';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../../../../../i18n';
import CopyIcon from '../../../../../icons/CopyIcon';

const ReusePoll = () => {
  const { t } = useTranslation([i18nNS.SHARED]);

  const { isOpen, handleClickReusePoll, handleCloseDrawer } = useReusePoll();

  return (
    <>
      <Tooltip title={t('copy_to_lecture', { ns: i18nNS.SHARED })}>
        <Button variant="text" size="small" onClick={handleClickReusePoll}>
          <CopyIcon size={20} aria-hidden />
        </Button>
      </Tooltip>
      <ReusePollDrawer open={isOpen} onClose={handleCloseDrawer} />
    </>
  );
};

export default ReusePoll;
